import { storeBadges } from "./data.js";

export default function CTA() {
  return (
    <section className="relative overflow-hidden bg-[#4C42FD] px-4 py-24 text-center sm:px-6 lg:px-8 lg:py-36">
      <div className="absolute inset-0 bg-[radial-gradient(rgba(255,255,255,0.08)_1px,transparent_1px)] [background-size:40px_40px]" style={{ willChange: 'transform', transform: 'translateZ(0)' }} />
      <div className="relative mx-auto max-w-5xl">
        <div className="inline-flex items-center gap-3 rounded-full border border-white/20 bg-white/10 px-5 py-2 text-[11px] font-bold uppercase tracking-[0.22em] text-white font-montserrat">
          * Get Started Today
        </div>

        <h2 className="mt-8 text-4xl font-black leading-[0.95] tracking-[-0.05em] text-white sm:text-6xl lg:text-8xl font-montserrat">
          Start once.
          <br />
          <span className="bg-gradient-to-r from-purple-100 to-white bg-clip-text text-transparent">
            Your money runs
            <br />
            automatically.
          </span>
        </h2>

      

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          {storeBadges.map((badge) => (
            <a
              key={badge.alt}
              href={badge.href}
              target="_blank"
              rel="noreferrer"
              className="transition duration-300 md:hover:scale-105"
            >
              <img src={badge.imgUrl} alt={badge.alt} className="h-12 w-auto sm:h-14" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
